import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { EditorialMarquee } from "@/components/landing/Marquee";
import { BeforeAfter } from "@/components/landing/BeforeAfter";
import { Services } from "@/components/landing/Services";
import { Gallery } from "@/components/landing/Gallery";
import { Process } from "@/components/landing/Process";
import { QuoteForm } from "@/components/landing/QuoteForm";
import { Footer } from "@/components/landing/Footer";

export default function LandingPage() {
  return (
    <main data-testid="landing-page" className="bg-[#050505] text-white min-h-screen">
      <Header />
      <Hero />
      <EditorialMarquee />
      <BeforeAfter />
      <Services />
      <Gallery />
      <Process />
      <QuoteForm />
      <Footer />
    </main>
  );
}
